<template>
    <Teleport to="body">
        <div class="modal fade" ref="root" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title f:20!">檢舉</h3>
                        <button class="btn-close" data-bs-dismiss="modal" type="button"></button>
                    </div>
                    <div class="modal-body {p:24|64!}@sm">
                        <div class="font:bold f:14 color:#333 mb:8">選擇檢舉類別</div>
                        <div class="mb:16 rel">
                            <select2 class="select2-container-in-modal" :options="reasons" placeholder="請選擇" v-if="reasons" v-model="data.category_id"></select2>
                        </div>
                        <div class="font:bold f:14 color:#333 mb:8">詳細說明</div>
                        <div class="mb:32">
                            <textarea class="form-control" placeholder="請描述您遇見的問題" rows="5" v-model.trim="data.content"></textarea>
                            <div class="flex jc:end">
                                <form-control-counter :value="data.content?.length" max="1000"></form-control-counter>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="w:full flex jc:center gap:24">
                            <button class="btn btn-primary" @click="inform" :disabled="!data?.category_id || !data?.content" type="button">送出</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
    const root = ref();

    const data = ref({});
    const reasons = ref([]);

    let modal;

    const inform = () => {
        api("api/topic/inform", data.value).done((res) => {
            if (res.success) {
                modal.hide();
                useGlobal().success("已成功送出");
            }
        });
    };

    const show = (id) => {
        api("app/topic/list-inform-category").done((res) => {
            if (res.success) {
                reasons.value = res.data;
                data.value = { topic_id: id, category_id: null, content: null };
                modal.show();
            }
        });
    };

    defineExpose({ show });

    onMounted(() => {
        modal = new bootstrap.Modal(root.value);
    });
</script>
